@if (loading) {
  <div class="page-loading">
    <span>
      <span></span>
    </span>
  </div>
}
<div class="my-ballots my-orders grid-layout">
  <div class="row clearfix max-width">
    <div class="small-12 columns account-row">
      <a (click)="navigate('/Users/my-profile')" title="">
        <span class="fa fa-fw fa-arrow-left"></span> Back to My Account
      </a>
    </div>
  </div>
  <div class="row clearfix max-width">
    <div class="small-12 columns header-row account-row">
      <h2>My Orders</h2>
    </div>
  </div>
  @for (entry of orders; track entry) {
    @if (entry.Product.ticket || entry.Product.product) {
      <div class="item" [ngClass]="entry.state">
        @if (entry.Product.ticket) {
          <ticket-component
            [ticket]="entry"
          ></ticket-component>
        }
        @if (entry.Product.product) {
          <product-component
            [product]="entry"
          ></product-component>
        }
      </div>
    }
  }
</div>
